'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import { Map as ImmutableMap } from 'immutable';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getFileFilteringErrorMessageKey, getFileFilteringErrorMessageOptions } from '../../utils/i18n';
import { jsx as _jsx } from "react/jsx-runtime";
export default class FileExtensionIsNotSupportedError extends Component {
  renderContent() {
    const {
      fileExtension,
      filter
    } = this.props;
    const reasons = filter.get('reasons');
    if (reasons.has(fileExtension)) {
      return /*#__PURE__*/_jsx("span", {
        children: reasons.get(fileExtension)
      });
    }
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: getFileFilteringErrorMessageKey(filter.get('filterType')),
      options: getFileFilteringErrorMessageOptions(filter.get('extensions')),
      "data-test-id": "file-extension-not-supported"
    });
  }
  render() {
    return /*#__PURE__*/_jsx("div", {
      className: "m-bottom-2",
      children: this.renderContent()
    });
  }
}
FileExtensionIsNotSupportedError.propTypes = {
  fileExtension: PropTypes.string.isRequired,
  filter: PropTypes.instanceOf(ImmutableMap).isRequired
};